var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuture4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "white",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.95 22.5H24.1667C23.7246 22.5 23.3007 22.6756 22.9882 22.9882C22.6756 23.3007 22.5 23.7246 22.5 24.1667V27.95",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 12.7832V14.1665C15.8335 14.8296 16.0969 15.4655 16.5657 15.9343C17.0346 16.4031 17.6705 16.6665 18.3335 16.6665C18.7755 16.6665 19.1994 16.8421 19.512 17.1547C19.8246 17.4673 20.0002 17.8912 20.0002 18.3332C20.0002 19.2499 20.7502 19.9999 21.6668 19.9999C22.1089 19.9999 22.5328 19.8243 22.8453 19.5117C23.1579 19.1992 23.3335 18.7752 23.3335 18.3332C23.3335 17.4165 24.0835 16.6665 25.0002 16.6665H27.6418",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1668 28.2915V24.9998C19.1668 24.5578 18.9912 24.1339 18.6787 23.8213C18.3661 23.5088 17.9422 23.3332 17.5002 23.3332C17.0581 23.3332 16.6342 23.1576 16.3217 22.845C16.0091 22.5325 15.8335 22.1085 15.8335 21.6665V20.8332C15.8335 20.3911 15.6579 19.9672 15.3453 19.6547C15.0328 19.3421 14.6089 19.1665 14.1668 19.1665H11.7085",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 28.3332C24.6022 28.3332 28.3332 24.6022 28.3332 19.9998C28.3332 15.3975 24.6022 11.6665 19.9998 11.6665C15.3975 11.6665 11.6665 15.3975 11.6665 19.9998C11.6665 24.6022 15.3975 28.3332 19.9998 28.3332Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuture4);
export default __webpack_public_path__ + "static/media/future-4.c48fd046929956ff58de4fdf9208485b.svg";
export { ForwardRef as ReactComponent };